import React from "react";
//import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";

function ContactPage() {
  return (
    <div>
      <Navbar />
      <h1 className="text-green-300 text-3xl font-bold underline">
        This is the Contact Page
      </h1>
    </div>
  );
}

export default ContactPage;
